/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Cmp_Clickup_Kb2Inputs */

const en_mk_cmp_clickup_kb2 = /** @type {(inputs: Mk_Cmp_Clickup_Kb2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Few concepts: issues, divisions, agents, memory. Usable on day one.`)
};

const id_mk_cmp_clickup_kb2 = /** @type {(inputs: Mk_Cmp_Clickup_Kb2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sedikit konsep: issue, divisi, agen, memori. Bisa dipakai di hari pertama.`)
};

/**
* | output |
* | --- |
* | "Few concepts: issues, divisions, agents, memory. Usable on day one." |
*
* @param {Mk_Cmp_Clickup_Kb2Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cmp_clickup_kb2 = /** @type {((inputs?: Mk_Cmp_Clickup_Kb2Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cmp_Clickup_Kb2Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cmp_clickup_kb2(inputs)
	return en_mk_cmp_clickup_kb2(inputs)
});